module.exports = __webpack_public_path__ + "static/media/JustAct_Logo_TM_V4-01.04180fac.png";